export default __webpack_public_path__ + "static/adylet (1)-412ebc0e5de62249768a46b93a072c6a.png";